module.exports = __webpack_public_path__ + "img/video-frase.34ec51af.jpg";